import React from "react";

const LinkOutlined = () => {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.802619"
        y="0.529182"
        width="63.0588"
        height="63.0588"
        rx="14.5882"
        fill="#E9ECF0"
        stroke="#E0E3E8"
        strokeWidth="0.941176"
      />
      <path
        d="M34.0816 24.4863L30.9742 27.5936L29.0332 25.6525L32.1407 22.5451C33.4276 21.2585 35.173 20.5356 36.9928 20.5356C38.8125 20.5356 40.5577 21.2584 41.8447 22.545C42.4833 23.1822 42.99 23.9391 43.3357 24.7724C43.6817 25.6062 43.8598 26.5 43.8598 27.4027C43.8598 28.3054 43.6817 29.1992 43.3357 30.033C42.9898 30.8667 42.4827 31.624 41.8436 32.2615L38.7357 35.3584L36.798 33.4139L39.905 30.318C40.2882 29.9356 40.5928 29.4809 40.8003 28.9809C41.0079 28.4806 41.1147 27.9443 41.1147 27.4027C41.1147 26.8611 41.0079 26.3248 40.8003 25.8245C40.5927 25.3243 40.2885 24.8699 39.905 24.4874L39.9039 24.4863C39.1318 23.7144 38.0846 23.2807 36.9928 23.2807C35.901 23.2807 34.8537 23.7145 34.0816 24.4863Z"
        fill="#33C3A0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8685 30.7014L24.7612 33.8086C24.7612 33.8087 24.7613 33.8086 24.7612 33.8086C23.9894 34.5807 23.5556 35.628 23.5556 36.7198C23.5556 37.8115 23.9892 38.8586 24.7609 39.6307C25.5331 40.4024 26.5804 40.8363 27.6721 40.8363C28.7639 40.8363 29.811 40.4027 30.5831 39.6308L33.6906 36.5234L35.6317 38.4644L32.5243 41.572C31.2372 42.8585 29.4919 43.5814 27.6721 43.5814C25.8524 43.5814 24.1071 42.8586 22.8202 41.5721C21.5336 40.2851 20.8105 38.5396 20.8105 36.7198C20.8105 34.9 21.5333 33.1548 22.8199 31.8678L25.9275 28.7603L27.8685 30.7014Z"
        fill="#33C3A0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0264 28.3644C36.5624 28.9004 36.5624 29.7695 36.0264 30.3055L30.5912 35.7408C30.0551 36.2768 29.1861 36.2768 28.6501 35.7408C28.114 35.2048 28.114 34.3357 28.6501 33.7997L34.0854 28.3644C34.6213 27.8284 35.4904 27.8284 36.0264 28.3644Z"
        fill="#33C3A0"
      />
    </svg>
  );
};

export default LinkOutlined;
